import type { ReactElement } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * PT-5 C6 — the tooltip for controls that repeat on EVERY row (To post, restore reading, memo clear).
 *
 * Built with the shared Radix Tooltip, as the ticket asks, then measured: UI-GUIDELINES §8 warns that a Radix root
 * per row of a long list cost the landing 239 ms once. If the render-cost [MEASURE] (40 rows) fails, set this to
 * `'native'` and every per-row tip becomes a native `title` in one change, the §5 exception named in BUILD_LOG.
 */
const ROW_TIP_MODE = 'radix' as 'radix' | 'native';

export function RowTip({ tip, children }: { tip: string; children: ReactElement<{ title?: string }> }) {
  if (ROW_TIP_MODE === 'native') {
    return <span title={tip} className="contents">{children}</span>;
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent className="max-w-xs">{tip}</TooltipContent>
    </Tooltip>
  );
}
